import * as FileApiHelper from './Helper';
import * as FileApiWrapper from './Wrapper';

export interface ContainerLoadFunctions {
    getTextFile(filename: string): Promise<string | null>;
    getBinaryFile(filename: string): Promise<ArrayBuffer | null>;
}

export interface ContainerWriteFunctions {
    addFile(data: ArrayBuffer | string, filename: string): Promise<void>;
}

export abstract class DirectoryContainer {
    public constructor(protected basePath: string) {
    }

    public getPath(path: string = ''): string {
        return this.basePath + path;
    }
}

export class DirectoryWriter extends DirectoryContainer implements ContainerWriteFunctions {
    public addFile(data: ArrayBuffer | string, filename: string): Promise<void> {
        return FileApiHelper.writeFile(this.getPath(filename), data);
    }
}

export class DirectoryReader extends DirectoryContainer implements ContainerLoadFunctions {
    public getTextFile(filename: string): Promise<string | null> {
        return FileApiHelper.readTextFile(this.getPath(filename));
    }

    public getBinaryFile(filename: string): Promise<ArrayBuffer | null> {
        return FileApiHelper.readBinaryFile(this.getPath(filename));
    }

    public async getJsonFile<T>(filename: string): Promise<T | null> {
        const content: string | null = await this.getTextFile(filename);
        if (content == null) {
            return null;
        }

        return JSON.parse(content) as T;
    }
}

export class DirectoryAccessContainer extends DirectoryContainer implements DirectoryReader, DirectoryWriter {
    protected reader: DirectoryReader;
    protected writer: DirectoryWriter;

    public constructor(protected basePath: string) {
        super(basePath);

        this.reader = new DirectoryReader(basePath);
        this.writer = new DirectoryWriter(basePath);
    }

    public getTextFile(filename: string): Promise<string | null> {
        return this.reader.getTextFile(filename);
    }

    public getBinaryFile(filename: string): Promise<ArrayBuffer | null> {
        return this.reader.getBinaryFile(filename);
    }

    public getJsonFile<T>(filename: string): Promise<T | null> {
        return this.reader.getJsonFile(filename);
    }

    public addFile(data: ArrayBuffer | string, filename: string): Promise<void> {
        return this.writer.addFile(data, filename);
    }

    public list(path?: string): Promise<Array<string>> {
        return FileApiWrapper.list(this.getPath(path == null ? '' : path));
    }

    public delete(path: string): Promise<void> {
        return FileApiWrapper.remove(this.getPath(path));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/app-api/Filesystem/Container.ts